export default __webpack_public_path__ + "5f5bc1bee12d3458494ec66b0c54a429.svg";